import React from 'react';

const CopyWithMedia = () => {
  return (
    <div className='w-full h-screen  px-4 sm:px-6 pt-12'>
      <div className='max-w-[1400px] w-full h-screen mx-auto text-center flex flex-col justify-center relative '>
        <div className='flex flex-col-reverse md:flex-row items-center justify-center mx-auto md:w-[75%]'>

          {/* Left Column (Text) */}
          <div className='w-[400px] mx-auto md:w-[550px] h-[550px] md:h-[475px] bg-white rounded-2xl flex flex-col justify-center border-2 border-cyan-500 -mt-8 pt-12 pb-8 md:pt-5 md:pb-5 md:mt-0 md:-mr-10 md:pr-20 md:pl-10 relative z-10'>
            <div className='flex flex-col justify-center mx-6'>
              <div>
                <p className='text-4xl font-bold border-b-4 border-cyan-500 text-black-800 inline-block'>It's Me</p>
              </div>
              <p className='md:w-[400px] mt-3 mx-auto md:text-md text-lg '>
                Born and raised in Ohio, I’ve always found inspiration in the connections I build and the stories I encounter. As a graduate of the University of Akron, my passion for design has been shaped by both my roots and my experiences. I genuinely enjoy meeting new people, exchanging ideas, and talking about life, which fuels my work and brings a human-centered approach to my designs. Through each project, I aim to create visuals that resonate personally and professionally, making every design an opportunity to share in someone’s journey.
              </p>
            </div>
          </div>

          {/* Right Column (Image) */}
          <div className='w-full md:w-[600px] flex flex-col justify-center relative z-20 flex-shrink-0'>
            <img
              className='w-full h-auto object-cover rounded-2xl'
              alt=''
              src='/images/me2.jpg'
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default CopyWithMedia;